export default __webpack_public_path__ + "static/02-03-writing-spelling-feedback-46c044362c854046cc368cbe7580adcf.mp4";